import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from './env.service';

export class ComentarioCasoModel {
  _id?: string;
  idCaso: string;
  nombreUsuarioComentario: string;
  comentarioText: string;
  createdAt: Date;
  updatedAt?: Date;
  deleted: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ComentarioCasoService {
  url = `${this.env.URL_API}/comenCaso`;

  constructor(public http: HttpClient, private env: EnvService) { }

  get(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}`);
  }

  post(caso: ComentarioCasoModel): Observable<any> {
    return this.http.post(`${this.url}`, caso);
  }

  put(id: string, caso: ComentarioCasoModel): Observable<any> {
    return this.http.put(`${this.url}/${id}`, caso);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.url}/${id}`);
  }

}
